import { BASKET_ITEM_GOOGLE_DISCOUNT_PRICE, BASKET_ITEM_SPECIAL_PRICE } from "theme/config/constants";
import {
    UPDATE_BASKET_ITEM,
    UPDATE_BASKET_ITEM_ERROR,
    UPDATE_BASKET_ITEM_SUCCESS,
} from "core-web/state/models/Basket/constants";

import { BasketEvents } from "core-web/libs/Events/constants";
import Events from "core-web/libs/Events";
import UpdateBasketItem from "core-web/libs/GrebbCommerceAPI/Basket/UpdateBasketItem";
import { acquireMutex } from "core-web/state";
import addMemberPromotions from "./addMemberPromotions";
import buildCartProductTree from "core-web/utils/buildCartProductTree";
import getBasketInfoFieldByCode from "core-web/state/models/Basket/utils/getBasketInfoFieldByCode";
import getItemById from "core-web/state/models/Basket/utils/getItemById";

import setBasketItemsAmountCookie from "core-web/state/models/Basket/utils/setBasketItemsAmountCookie";
import store from "core-web/state/store";
import tracking from "core-web/components/Tracking";

export const updateBasketItem =
    (basketId, partNo, basketItemId, quantity, pricelistId, source, manualPrice) => async (dispatch, getState) => {
        // Should this even be possible if we haven't already fetched the Basket prior to this?
        const mutexLock = await acquireMutex("basket.getBasket");
        const eventId = tracking.getUniqueId();

        dispatch({ type: UPDATE_BASKET_ITEM });
        try {
            const basket = getState().basket;
            const trackedItem = { ...(getItemById(basketItemId, basket.items) || {}) };

            if (source === "remove") {
                trackedItem.quantity = trackedItem.quantity - quantity;
            }
            if (source === "add") {
                trackedItem.quantity = quantity - trackedItem.quantity;
            }

            const basketItemInfo = trackedItem.info || [];
            const googleDiscountPrice = getBasketInfoFieldByCode(
                BASKET_ITEM_GOOGLE_DISCOUNT_PRICE,
                basketItemInfo,
            )?.value;
            const specialPrice = getBasketInfoFieldByCode(BASKET_ITEM_SPECIAL_PRICE, basketItemInfo)?.value;

            const response = await UpdateBasketItem(
                basketId,
                partNo,
                basketItemId,
                quantity,
                pricelistId,
                eventId,
                manualPrice || specialPrice || googleDiscountPrice,
            );

            const basketItemsTree = buildCartProductTree(response.data.items);
            const basketItemsCount = basketItemsTree.reduce((total, item) => total + (item.quantity || 0), 0);
            setBasketItemsAmountCookie(basketItemsCount);

            dispatch({
                type: UPDATE_BASKET_ITEM_SUCCESS,
                items: basketItemsTree,
                info: response.data.info || [],
                summary: response.data.format.summary,
                promotions: response.data.applied_promotions,
                addedItem: basketItemId,
            });

            Events.trigger(BasketEvents.UPDATED);

            if (source === "add") {
                Events.trigger(BasketEvents.PRODUCT_ADDED, {
                    basketId,
                    item: trackedItem,
                    eventId,
                });
            } else if (source === "remove") {
                Events.trigger(BasketEvents.PRODUCT_REMOVED, {
                    basket: basketId,
                    item: trackedItem,
                    eventId: eventId,
                });
            }

            mutexLock();

            const activeMemberPromotions = getState().basket.activeMemberPromotions;
            if (activeMemberPromotions?.length) {
                const activeMemberPromotionIds = activeMemberPromotions.map((promotion) => promotion.id);
                addMemberPromotions(activeMemberPromotionIds);
            }

            return response;
        } catch (e) {
            dispatch({ type: UPDATE_BASKET_ITEM_ERROR });

            mutexLock();

            throw e;
        }
    };

export default (basketId, partNo, basketItemId, quantity, pricelistId, source, manualPrice) =>
    store.dispatch(updateBasketItem(basketId, partNo, basketItemId, quantity, pricelistId, source, manualPrice));
